export default __webpack_public_path__ + "static/responsive-design2-ed25fe2c20c5869a272e58edc4e4d5c8.png";